import { useTranslation } from "react-i18next";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  DialogContentText,
  useTheme,
  styled,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";

type Props = {
  open: boolean;
  isLoading: boolean;
  close: () => void;
  confirm: () => Promise<void>;
};

const DeleteARFileDialog = (props: Props) => {
  const { t } = useTranslation();

  const handleClose = () => {
    props.close();
  };

  const removeFile = async () => {
    await props.confirm();
  };

  const theme = useTheme();

  const customColor = {
    color: theme.palette.base.contrast,
  };

  const customModalColor = {
    color: theme.palette.base.modal,
  };

  const customDialogBackgroundColor = {
    color: theme.palette.base.dialogBackground,
  };

  const customLoadingButtonColor = {
    background: theme.palette.btn.error.backgroundColor,
    border: theme.palette.btn.error.border,
    boxShadow: "none",
  };

  const CustomCanselButton = styled(Button)({
    background: theme.palette.base.modal,
    color: theme.palette.base.contrast,
    boxShadow: "none",
    "&:hover": {
      background: theme.palette.base.modal,
      color: theme.palette.base.contrast,
      boxShadow: "none",
    },
  });

  return (
    <Dialog
      open={props.open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{
        className: "del-dialog4",
        style: {
          background: customModalColor.color,
        },
      }}
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: customDialogBackgroundColor.color,
          },
        },
      }}
    >
      <DialogTitle
        style={customColor}
        className="title-name"
        id="alert-dialog-title"
      >
        {t("REMOVE")}
        <Button
          style={customColor}
          className="x-btn btn-remove"
          onClick={handleClose}
        >
          ×
        </Button>
        <div className="border-comm" />
      </DialogTitle>
      <DialogContent>
        <DialogContentText style={customColor} className="del-dialog5">
          {t("DELETE_FILE_CONFIRM")}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <CustomCanselButton
          size="small"
          variant="contained"
          onClick={handleClose}
          className="del-dialog6"
        >
          {t("CANCEL")}
        </CustomCanselButton>
        <LoadingButton
          style={customLoadingButtonColor}
          loading={props.isLoading}
          size="small"
          variant="contained"
          onClick={removeFile}
          className="loading-white del-dialog7"
        >
          {t("REMOVE")}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};
export default DeleteARFileDialog;
